var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _vm.userPermissions.indexOf("add_location_departments") > -1
        ? _c("div", { staticClass: "container-fluid xyz" }, [
            _c("div", { staticClass: "page-header-top-container" }, [
              _c("div", { staticClass: "page-name" }, [
                _vm._v(_vm._s(_vm.pageTitle))
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "back_button btn btn-primary pull-right",
                  attrs: { type: "submit" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.buttonBack.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("Back")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "admin-page-content" }, [
              _c("form", { attrs: { id: "benefitForm" } }, [
                _c("div", { staticClass: "forms-container" }, [
                  _c("div", { staticClass: "row no-margin" }, [
                    _c("div", { staticClass: "col-6 forms-block" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-9 paddingleft0" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.name,
                                expression: "name"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              id: "name",
                              placeholder: "Name"
                            },
                            domProps: { value: _vm.name },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.name = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "requiredstar" }, [
                            _vm._v("*")
                          ]),
                          _vm._v(" "),
                          _c("font", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(_vm.nameError))
                          ])
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6 forms-block" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-9 paddingleft0" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.alias,
                              expression: "alias"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "alias",
                            placeholder: "Alias"
                          },
                          domProps: { value: _vm.alias },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.alias = $event.target.value
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6 forms-block" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-9 paddingleft0" },
                        [
                          _c(
                            "v-select",
                            {
                              attrs: {
                                name: "companyId",
                                id: "companyId",
                                label: "text",
                                filterable: false,
                                options: _vm.companyArr,
                                placeholder: "Select Company"
                              },
                              on: {
                                change: _vm.changedValue,
                                input: function($event) {
                                  return _vm.changedValueUser()
                                },
                                search: _vm.onSearchCompany
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "option",
                                    fn: function(option) {
                                      return [
                                        _c("div", { staticClass: "d-center" }, [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(option.text) +
                                              "\n                                        "
                                          )
                                        ])
                                      ]
                                    }
                                  },
                                  {
                                    key: "selected-option",
                                    fn: function(option) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "selected d-center" },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(option.text) +
                                                "\n                                        "
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                570241188
                              ),
                              model: {
                                value: _vm.companyId,
                                callback: function($$v) {
                                  _vm.companyId = $$v
                                },
                                expression: "companyId"
                              }
                            },
                            [
                              _c("template", { slot: "no-options" }, [
                                _vm._v(
                                  "\n                                        Search Company...\n                                    "
                                )
                              ])
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "requiredstar" }, [
                            _vm._v("*")
                          ]),
                          _vm._v(" "),
                          _c("font", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(_vm.companyIdError))
                          ])
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6 forms-block" }, [
                      _vm._m(3),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-9 paddingleft0" },
                        [
                          _c("v-select", {
                            attrs: {
                              name: "locationType",
                              id: "locationType",
                              label: "text",
                              clearable: false,
                              searchable: true,
                              filterable: false,
                              options: _vm.locationTypeArr,
                              placeholder: "Select Location"
                            },
                            on: { search: _vm.onSearchState },
                            model: {
                              value: _vm.locationType,
                              callback: function($$v) {
                                _vm.locationType = $$v
                              },
                              expression: "locationType"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "requiredstar" }, [
                            _vm._v("*")
                          ]),
                          _vm._v(" "),
                          _c("font", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(_vm.locationTypeError))
                          ])
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm._m(4),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "col-12 paddingleft0" }, [
                        _c("input", {
                          staticClass: "btn btn-primary",
                          attrs: {
                            id: "addLocationBtn",
                            type: "submit",
                            value: "Save"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.addLocation()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "btn btn-primary",
                          attrs: {
                            id: "addAndContinueLocationBtn",
                            type: "submit",
                            value: "Save and Continue"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.addLocation(
                                (_vm.flag = "Save and Continue")
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "back_button btn btn-primary",
                          attrs: {
                            id: "CancelLocation",
                            type: "submit",
                            value: "Cancel"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.buttonBack.apply(null, arguments)
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        : _c("div", { staticClass: "container-fluid xyz" }, [
            _c("div", { staticClass: "page-name" }, [
              _vm._v("\n            Oops...!\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "admin-page-content" }, [
              _vm._v(
                "\n            Sorry, You don't have permission to access this page.\n        "
              )
            ])
          ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "name" } }, [
        _vm._v("Name :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "alias" } }, [
        _vm._v("Alias :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "companyId" } }, [
        _vm._v("Company :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "companyId" } }, [
        _vm._v("State :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "col-12 paddingleft0" }, [
        _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
          [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b31a98c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b31a98c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/ManageLocation/AddLocation.vue
// module id = null
// module chunks = 